import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface SearchSuggestionsDropdownSectionProps {
  title?: ReactNode;
}

/*
 * Style.
 */

const StyledSearchSuggestionsDropdownSectionWrapperDiv = styled.div`
  &:not(:last-of-type) {
    border-bottom: 1px solid ${(p) => p.theme.greys.shade30};
  }
`;

const StyledSearchSuggestionsDropdownSectionDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding: 7px 0 6px;
`;

const StyledSearchSuggestionsDropdownSectionTitleDiv = styled.div`
  display: flex;
  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.semibold};
  line-height: ${fontSizes.large};
  padding: 8px 16px 4px 16px;
`;

/*
 * Component.
 */

export const SearchSuggestionsDropdownSection: FC<
  PropsWithChildren<SearchSuggestionsDropdownSectionProps>
> = (props) => {
  const {title, children} = props;

  return (
    <StyledSearchSuggestionsDropdownSectionWrapperDiv>
      <StyledSearchSuggestionsDropdownSectionDiv>
        <StyledSearchSuggestionsDropdownSectionTitleDiv>
          {title ?? <Trans id="inboxes-search-suggestions">Suggestions</Trans>}
        </StyledSearchSuggestionsDropdownSectionTitleDiv>
        {children}
      </StyledSearchSuggestionsDropdownSectionDiv>
    </StyledSearchSuggestionsDropdownSectionWrapperDiv>
  );
};
